import { render, staticRenderFns } from "./SalesLayout.vue?vue&type=template&id=7ca0b67c&"
import script from "./SalesLayout.vue?vue&type=script&lang=js&"
export * from "./SalesLayout.vue?vue&type=script&lang=js&"
import style0 from "./SalesLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports